import React, { Component } from "react";
import { Row, Col, Card, CardHeader, CardBody, Table, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import moment from "moment";
import pengumumandua from '../../images/pengumumandua.png';
import penggunaa from '../../images/pengguna-2.png';
import {Pie} from 'react-chartjs-2';
import Chart from '../../components/Chart';

import AddThnModal from '../../components/AddThnModal.js'
import AddKelasModal from '../../components/AddKelasModal.js'
import AddMapelModal from '../../components/AddMapelModal.js'

class Dashboard extends Component {
	constructor() {
		super();

		this.state = {
			isLoading: false,
			countAbsen: "00:00",
			countTodo: "0",
			countTugas: "0",
			countJadwal: "0",
			dataTugas: [],
			dataMateri: [],
			countPengumuman: "0",
			siswaOnline:"0",
			guruOnline:"0",
			waliOnline:"0",
			countPegawai:"0",
			user_online:"0",
			kelas:[],
			mapel:[],
			thnAjar:false,
			isModalShow: false,
			isModalKelasShow: false,
			isModalMapelShow: false,
		}

		this.toggleModal              = this.toggleModal.bind(this);
		this.toggleModalKelas         = this.toggleModalKelas.bind(this);
		this.toggleModalMapel         = this.toggleModalMapel.bind(this);
	}

	toggleModal() {
		this.setState({ isModalShow: ! this.state.isModalShow })
	}

	toggleModalKelas() {
		this.setState({ isModalKelasShow: ! this.state.isModalKelasShow })
	}

	toggleModalMapel() {
		this.setState({ isModalMapelShow: ! this.state.isModalMapelShow })
	}

	componentWillMount(){
		this.getChartData();
	}

	getChartData(){
		// Ajax calls here
		this.setState({
			chartData:{
				labels: ['Hadir','Telat','Izin','Tidak Hadir'],
				datasets:[
					{
						label:'Population',
						data:[
							14,
							4,
							5,
							8

						],
						backgroundColor:[
							'#4dbd74',
							'#ffc107',
							'#20a8d8',
							'#f86c6b'

						]
					}
				]
			}
		});
	}

	loadData() {
		this.setState({ isLoading: true });

		axios({
			method: "post",
			url: "/dashboard"
		})
		.then(response => {

			const result = response.data;
			if (result.success) {
				this.setState({
					isLoading: false,
					countAbsen: result.data.countPresensi,
					countTodo: result.data.countTodo,
					countTugas: result.data.countTugas,
					countJadwal: result.data.countJadwal,
					pegawaiCount:result.data.pegawaiCount,
					countGuru : result.data.countGuru,
					countSiswa : result.data.countSiswa,
					dataTugas: result.data.dataTugas,
					dataMateri: result.data.dataMateri,
					countPengumuman: result.data.countPengumuman,
					siswaOnline: result.data.siswaOnline,
					guruOnline: result.data.guruOnline,
					kelas: result.data.kelas,
					mapel: result.data.mapel,
					thnAjar: result.data.thnAjar
				});
			} else {
				Alert.error(result.message);
				this.setState({ isLoading: false });
			}
			})
			.catch(error => {
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="animated fadeIn">
				<AddThnModal
					isShow={this.state.isModalShow}
					toggleModal={this.toggleModal}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Set tahun ajar"
					modalSubmitText="Ya"
				/>
				<AddKelasModal
					isShow={this.state.isModalKelasShow}
					toggleModalKelas={this.toggleModalKelas}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Set Kelas"
					modalSubmitText="Ya"
				/>

				<AddMapelModal
					isShow={this.state.isModalMapelShow}
					toggleModalKelas={this.toggleModalMapel}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Set Mapel"
					modalSubmitText="Ya"
				/>
				<div className="row">
					<div className="col-sm-6 col-lg-3">
						<div className="info-box bg-pink hover-expand-effect">
							<div className="icon">
								<img src={penggunaa} ></img>
							</div>
							<div className="content">
								<tables>
									<tr>
										<td>
											<table>
												<tr>
													<tr>
														<td>
															<div className="text">SISWA</div>
															<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.countSiswa}</div>
														</td>
														<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
														<td className="icon fa fa-laptop text-2 float-right">
															<br></br>ONLINE&nbsp;:&nbsp;{this.state.siswaOnline}
														</td>

													</tr>
													<tr>
														<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
													</tr>
												</tr>
											</table>
										</td>
										<td>

										</td>
									</tr>

								</tables>
								</div></div></div>

					<div className="col-sm-6 col-lg-3">
						<div className="info-box bg-cyan hover-expand-effect">
							<div className="icon">
								<img src={penggunaa} ></img>
							</div>
							<div className="content">
								<tables>
									<tr>
										<td>
											<table>
												<tr>
													<tr>
														<td>
															<div className="text">&nbsp;GURU</div>
															<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">&nbsp;{this.state.countGuru}</div>
														</td>
														<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
														<td className="icon fa fa-laptop text-2 float-right">
															<br></br>ONLINE&nbsp;:&nbsp;{this.state.guruOnline}
														</td>

													</tr>
													<tr>
														<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
													</tr>
												</tr>
											</table>
										</td>
										<td>

										</td>
									</tr>

								</tables>
							</div></div></div>
					{/*<div className="col-sm-6 col-lg-3">*/}
					{/*	<div className="info-box bg-cyan hover-expand-effect">*/}
					{/*		<div className="icon">*/}
					{/*			<img src={penggunaa} ></img>*/}
					{/*		</div>*/}
					{/*		<div className="content">*/}
					{/*			<tables>*/}
					{/*				<tr>*/}
					{/*					<td>*/}
					{/*						<div className="text">GURU</div></td>*/}
					{/*					<td>&nbsp;&nbsp;&nbsp;</td>*/}
					{/*					<td>*/}
					{/*						<div className="text">ONLINE</div></td>*/}

					{/*				</tr>*/}
					{/*				<tr>*/}
					{/*					<td className="center">*/}
					{/*						<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.countGuru}</div>*/}
					{/*					</td>*/}
					{/*					<td>&nbsp;&nbsp;</td>*/}
					{/*					<td className="center">*/}
					{/*						<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.guruOnline}</div>*/}

					{/*					</td>*/}
					{/*				</tr>*/}
					{/*			</tables>*/}
					{/*		</div></div></div>*/}
					{/*<div className="col-sm-6 col-lg-3">*/}
					{/*	<div className="info-box bg-cyan hover-expand-effect">*/}
					{/*		<div className="icon">*/}
					{/*			<img src={penggunaa} ></img>*/}
					{/*		</div>*/}
					{/*		<div className="content">*/}
					{/*			<div className="text">JUMLAH GURU</div>*/}
					{/*			<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.countGuru}</div>*/}
					{/*		</div></div></div>*/}
					<div className="col-sm-6 col-lg-3">
						<div className="info-box bg-warning hover-expand-effect">
							<div className="icon">
								<img src={penggunaa} ></img>
							</div>
							<div className="content">
								<tables>
									<tr>
										<td>
											<div className="text">JUMLAH PEGAWAI</div></td>
										<td>&nbsp;&nbsp;</td>

									</tr>
									<tr>
										<td>
											<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.pegawaiCount}</div>
										</td>

									</tr>
								</tables>
							</div></div></div>
					<div className="col-sm-6 col-lg-3">
					<div className="info-box bg-light-green hover-expand-effect">
						<div className="icon">
							<img src={pengumumandua} ></img>
						</div>
						<div className="content">
							<tables>
								<tr>
									<td>
										<div className="text">JUMLAH PENGUMUMAN</div></td>


								</tr>
								<tr>
									<td>
										<div className="number count-to" data-from="0" data-to="300" data-speed="1000" data-fresh-interval="20">{this.state.countPengumuman}</div>
									</td>

								</tr>
							</tables>
						</div></div></div>
					{/*<div className="col-sm-6 col-lg-3">*/}
					{/*	<div className="info-box bg-light-green hover-expand-effect">*/}
					{/*		<div className="content">*/}

					{/*			<table>*/}
					{/*				<tr>*/}
					{/*					<td>Siswa</td>*/}
					{/*					<td>Guru</td>*/}
					{/*					*/}
					{/*				</tr>*/}
					{/*				<tr>*/}
					{/*					<td>{this.state.siswaOnline}</td>*/}
					{/*					<td>{this.state.guruOnline}</td>*/}
					{/*				</tr>*/}
					{/*			</table>*/}
					{/*			/!*<div className="text"><strong> Siswa Online : {this.state.siswaOnline}</strong></div>*!/*/}
					{/*			/!*<div className="text"><strong> Guru Online : {this.state.guruOnline}</strong></div>*!/*/}
					{/*			/!*<div className="text"><strong> Wali Online : {this.state.waliOnline}</strong></div>*!/*/}


					{/*		</div></div></div>*/}
				</div>

				{/*<div className="card-columns cols-2">*/}
				{/*	<div className="card">*/}
				{/*		<div className="card-header">Rekap Absensi Siswa <sup>BETA</sup></div>*/}
				{/*		<div className="card-body">*/}
				{/*			<Chart chartData={this.state.chartData}  legendPosition="bottom"/>*/}
				{/*			<br/>*/}
				{/*			<br/>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}

				<div className="row">
					{this.state.isLoading ? (
						"Memuat Data..."
					) : (
						<div className="col-sm-12">
							{
								this.state.kelas.length > 0 &&
								this.state.mapel.length > 0 &&
								this.state.thnAjar ? (
									""
								) : (
									<Row>
										<Col>
											<div className="alert alert-danger" role="alert" style={{ textAlign:'center' }}>
												<h3>Mohon lengkapi pengaturan dibawah ini agar semua fitur dapat digunakan</h3><br/>
											</div>
										</Col>
									</Row>
								)
							}
							<Row>
								<Col xs="12" lg="4">
									<div className="card">
										<div className="card-header">
											TAHUN AJAR
										</div>
										<div className="card-block">
											{
												this.state.isLoading ? "Memuat Data..." : (
													!this.state.thnAjar ? (
														<div>
															<div className="alert alert-warning" role="alert" style={{ textAlign:'center' }}>
																Tahun ajar belum dibuat...<br/>
																<button
																	type="button"
																	className="btn btn-danger btn-sm"
																	onClick={() => {
																		this.toggleModal();
																	}}
																>
																	Set Tahun Ajar
																</button>
															</div>
														</div>
													) : (
														<div>
															<div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
																<h3>{this.state.thnAjar.thn_ajar_value}</h3><br/>
																{/*<h4>{this.state.thnAjar.thn_ajar_semester.toUpperCase()}</h4><br/>*/}
																<NavLink
																	to={"/tahun_ajar"}
																	target="_blank"
																	className="nav-link"
																	activeClassName="active"
																>
																	<i className="icon-pencil" /> Edit Tahun Ajar
																</NavLink>
															</div>
														</div>
													)
												)
											}
										</div>
									</div>
								</Col>
								<Col xs="12" lg="4">
									<div className="card">
										<div className="card-header">
											KELAS
										</div>
										<div className="card-block">
											{
												this.state.isLoading ? "Memuat Data..." : (
													this.state.kelas.length < 1 ? (
														<div>
															<div className="alert alert-warning" role="alert" style={{ textAlign:'center' }}>
																Kelas belum dibuat...<br/>
																<button
																	type="button"
																	className="btn btn-danger btn-sm"
																	onClick={() => {
																		this.toggleModalKelas();
																	}}
																>
																	Set Kelas Default
																</button>
															</div>
														</div>
													) : (
														<div>
															<div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
																<h3>{this.state.kelas[0].kelas_nama}</h3><br/>
																<NavLink
																	to={"/kelas"}
																	target="_blank"
																	className="nav-link"
																	activeClassName="active"
																>
																	<i className="icon-plus" /> Tambah Kelas
																</NavLink>
															</div>
														</div>
													)
												)
											}
										</div>
									</div>
								</Col>
								<Col xs="12" lg="4">
									<div className="card">
										<div className="card-header">
											MAPEL
										</div>
										<div className="card-block">
											{
												this.state.isLoading ? "Memuat Data..." : (
													this.state.mapel.length < 1 ? (
														<div>
															<div className="alert alert-warning" role="alert" style={{ textAlign:'center' }}>
																Mapel belum dibuat...<br/>
																<button
																	type="button"
																	className="btn btn-danger btn-sm"
																	onClick={() => {
																		this.toggleModalMapel();
																	}}
																>
																	Set Mapel Default
																</button>
															</div>
														</div>
													) : (
														<div>
															<div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
																<h3>{this.state.mapel[0].mapel_nama}</h3><br/>
																<NavLink
																	to={"/mapel"}
																	target="_blank"
																	className="nav-link"
																	activeClassName="active"
																>
																	<i className="icon-plus" /> Tambah Mapel
																</NavLink>
															</div>
														</div>
													)
												)
											}
										</div>
									</div>
								</Col>
							</Row>
							<Row>
								<Col xs="12" lg="6">
									<Card>
										<CardHeader>Tugas Sekolah</CardHeader>
										<CardBody>
											{this.state.dataTugas.length === 0 ? (
												"Data Kosong..."
											) : (
												<div>
													<Table responsive>
														<thead>
														<tr>
															<th>Pelajaran</th>
															<th>Deskripsi</th>
															<th>Status</th>
															<th>Due Date</th>
														</tr>
														</thead>
														<tbody>
														{this.state.dataTugas.map(item => {
															return (
																<tr key={item.tugas_id}>
																	<td>{item.mapel != null ? item.mapel.mapel_nama : "-"}</td>
																	<td>{item.tugas_judul}</td>
																	<td>
																		{item.tugas_status === "1" && (
																			<Badge color="success">Aktif</Badge>
																		)}
																		{item.tugas_status === "0" && (
																			<Badge color="danger">
																				Tidak Aktif
																			</Badge>
																		)}
																	</td>
																	<td>
																		{moment(item.tugas_due_date).format(
																			"DD MMM YYYY"
																		)}
																	</td>
																</tr>
															);
														})}
														</tbody>
													</Table>

													<div
														className="text-center"
														style={{ marginBottom: 20 }}
													>
														<NavLink to={`/tugas`} className="btn btn-primary">
															Tampilkan Semua
														</NavLink>
													</div>
												</div>
											)}
										</CardBody>
									</Card>
								</Col>
								<Col xs="12" lg="6">
									<Card>
										<CardHeader>Materi Pelajaran</CardHeader>
										<CardBody>
											{this.state.dataMateri.length === 0 ? (
												"Data Kosong..."
											) : (
												<div>
													<Table responsive>
														<thead>
														<tr>
															<th>File</th>
															<th>Nama</th>
															<th>Desc</th>
														</tr>
														</thead>
														<tbody>
														{this.state.dataMateri.map(item => {
															if (item.materi_tipe === "pdf") {
																var iconThumb = "fa fa-file-pdf-o bg-danger";
															} else if (
																item.materi_tipe === "xls" ||
																item.materi_tipe === "xlsx"
															) {
																var iconThumb = "fa fa-file-excel-o bg-success";
															} else if (
																item.materi_tipe === "doc" ||
																item.materi_tipe === "docx"
															) {
																var iconThumb = "fa fa-file-word-o bg-primary";
															}

															if (item.materi_filesize.length > 6) {
																var fileSize = Number(
																	item.materi_filesize / 1000000
																).toFixed(2);
																var fileUnit = "MB";
															} else {
																var fileSize = Number(
																	item.materi_filesize / 1000
																).toFixed(2);
																var fileUnit = "KB";
															}
															return (
																<tr key={item.materi_id}>
																	<td>
																		<i className={iconThumb} />&nbsp; {item.materi_judul}-
																		<small>{item.mapel != null ? item.mapel.mapel_nama : "-"}</small>
																	</td>
																	<td>
																		<div className="value" style={{ right: 10 }}>
																			<div className="small text-muted">
																				{item.user != null ? item.user.user_nama : '-'}
																			</div>
																		</div>
																	</td>
																	<td>
																		<div className="value" style={{ right: 10 }}>
																			<strong>
																				{fileSize}
																				{fileUnit}
																			</strong>
																		</div>
																	</td>
																</tr>
															);
														})}
														</tbody>
													</Table>
													<div
														className="text-center"
														style={{ marginBottom: 20 }}
													>
														<NavLink to={`/materi`} className="btn btn-primary">
															Tampilkan Semua
														</NavLink>
													</div>
												</div>
											)}
										</CardBody>
									</Card>
								</Col>
							</Row>
						</div>
					)}
				</div>


				{/*<div className="card-columns cols-2">*/}
				{/*	<div className="card">*/}
				{/*		<div className="card-header">Usefull link</div>*/}
				{/*		<table className="table table-striped table-bordered animated fadeIn">*/}
				{/*			<thead>*/}
				{/*			<tr>*/}
				{/*				<th>Website Sismart</th>*/}

				{/*			</tr>*/}
				{/*			</thead>*/}

				{/*		</table>*/}


				{/*	</div>*/}
				{/*</div>*/}

			</div>

		);
	}
}


export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js